import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
  vsServiceName as FormViewServiceName,
} from "../../../records/forms/formView";
import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import fieldHelpers from "../../../ui-formly/fieldHelpers";
import {
  LookupManagementConfig,
  LookupManagementServiceProvider,
  vsProviderName as LookupManagementServiceProviderName,
} from "../components/lookupManagement";
import { MachineDenomination } from "../models/machineConfiguration";

export const vsObjectName = "machineDenomination";

MachineDenominationConfig.$inject = [
  FormViewServiceProviderName,
  RecordGridViewServiceProviderName,
  LookupManagementServiceProviderName,
];

const url = "/api/machines/MachineDenomination";

export function MachineDenominationConfig(
  formViewServiceProvider: FormViewServiceProvider,
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  lookupManagementServiceProvider: LookupManagementServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(
    vsObjectName,
    getGridConfig
  );
  lookupManagementServiceProvider.addLookup(vsObjectName, {
    displayName: "Denomination",
    config: [
      ServerUtilityName,
      (serverUtility: ServerUtility) => {
        const config: LookupManagementConfig = {
          fetchFormModel(id) {
            return serverUtility.querySingle({
              url,
              query: { Id: id },
            });
          },
        };
        return config;
      },
    ],
  });
  formViewServiceProvider.addFormViewConfig(vsObjectName, getFormConfig);
}

getGridConfig.$inject = [ServerUtilityName, ColumnDefinitionServiceName];
function getGridConfig(
  serverUtility: ServerUtility,
  columnDefinitionService: ColumnDefinitionService
): GridConfiguration {
  return {
    columns: [
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Denomination",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Value",
        header: "Value",
      }),
    ],
    gridDataSource: new RecordDataSource(serverUtility, url),
    defaultSort: "Value,Name",
    namePlural: "Denonominations",
    nameSingular: "Denomination",
    showAddButton: true,
    showAddButtonPermission: "machineEdit",
    showSelectButtons: false,
  };
}

getFormConfig.$inject = [FormViewServiceName];
function getFormConfig(formViewService: FormViewService): FormViewConfig {
  return {
    fields: [
      fieldHelpers.simpleStringField({
        key: "Name",
        label: "Denomination",
        required: true,
      }),
      fieldHelpers.simpleCurrencyField({
        key: "Value",
        label: "Value",
        required: true,
      }),
    ],
    title: (model) => (model.Id ? "Edit Denomination" : "Create Denomination"),
    name: vsObjectName,
    submitForm: (args: FormSubmitArgs) => {
      const model = <MachineDenomination>args.model;
      return formViewService.saveForm({
        formObject: model,
        formViewController: args.formViewController,
        url,
      });
    },
  };
}
